import React from "react";

//WARNING!! PLease do not edit any of these icons
//These Files Consist of Custom Icons which has Multi Colors.

export const LogoPortProSmall = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9429 3.48571C16.2 2.37143 15.1714 1.51429 13.8571 0.914286C12.5143 0.314286 10.9429 0 9.14286 0H0V4.45714H8.8C9.94286 4.45714 10.8286 4.71429 11.4286 5.22857C12 5.74286 12.3143 6.48572 12.3143 7.4C12.3143 8.34286 12 9.05714 11.4286 9.57143C10.8286 10.0857 9.94286 10.3143 8.8 10.3143H0V20H5.65714V14.7714H9.14286C10.9429 14.7714 12.5143 14.4857 13.8571 13.8857C15.1714 13.2857 16.2 12.4286 16.9429 11.3143C17.6571 10.2286 18.0286 8.91429 18.0286 7.4C18.0286 5.91429 17.6571 4.6 16.9429 3.48571Z"
      fill="white"
    />
  </svg>
);
export const LogoPortPro = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="142"
    height="20"
    viewBox="0 0 142 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2165 20C28.1835 20 26.3429 19.5879 24.722 18.7088C23.1011 17.8571 21.8374 16.6758 20.9033 15.1374C19.9692 13.6264 19.5297 11.9231 19.5297 10C19.5297 8.1044 19.9692 6.4011 20.9033 4.86264C21.8374 3.35165 23.1011 2.17033 24.722 1.29121C26.3429 0.439559 28.1835 0 30.2165 0C32.2495 0 34.0627 0.439559 35.6835 1.29121C37.3044 2.17033 38.5681 3.35165 39.5022 4.86264C40.4363 6.4011 40.9033 8.1044 40.9033 10C40.9033 11.9231 40.4363 13.6264 39.5022 15.1374C38.5681 16.6758 37.3044 17.8571 35.6835 18.7088C34.0627 19.5879 32.2495 20 30.2165 20ZM30.2165 15.4945C31.178 15.4945 32.0572 15.2747 32.8539 14.8077C33.6231 14.3681 34.255 13.7088 34.722 12.8846C35.1616 12.0604 35.4088 11.0989 35.4088 10C35.4088 8.92857 35.1616 7.96703 34.722 7.14285C34.255 6.31868 33.6231 5.65934 32.8539 5.19231C32.0572 4.75275 31.178 4.50549 30.2165 4.50549C29.2275 4.50549 28.3484 4.75275 27.5791 5.19231C26.7824 5.65934 26.1506 6.31868 25.711 7.14285C25.244 7.96703 25.0242 8.92857 25.0242 10C25.0242 11.0989 25.244 12.0604 25.711 12.8846C26.1506 13.7088 26.7824 14.3681 27.5791 14.8077C28.3484 15.2747 29.2275 15.4945 30.2165 15.4945ZM13.5107 1.12639C14.7921 1.71139 15.795 2.54711 16.5193 3.63353C17.2157 4.71996 17.5779 6.00139 17.5779 7.44996C17.5779 8.92639 17.2157 10.2078 16.5193 11.2664C15.795 12.3528 14.7921 13.1885 13.5107 13.7735C12.2014 14.3585 10.6693 14.6371 8.91429 14.6371H5.51571V19.735H0V10.2914H8.58C9.69428 10.2914 10.5579 10.0685 11.1429 9.5671C11.7 9.06568 12.0064 8.36925 12.0064 7.44996C12.0064 6.55853 11.7 5.83425 11.1429 5.33282C10.5579 4.83139 9.69428 4.58068 8.58 4.58068H0V0.234961H8.91429C10.6693 0.234961 12.2014 0.54139 13.5107 1.12639ZM57.3238 13.5714C58.5051 12.9945 59.4392 12.1978 60.0985 11.1538C60.7578 10.1099 61.0875 8.9011 61.0875 7.5C61.0875 6.07143 60.7304 4.8077 60.0435 3.73627C59.3293 2.66484 58.3403 1.84066 57.0765 1.26374C55.7853 0.686817 54.2743 0.384619 52.5436 0.384619H43.7523V4.67033H52.2139C53.3128 4.67033 54.1644 4.91759 54.7414 5.41209C55.2908 5.9066 55.593 6.62088 55.593 7.5C55.593 8.4066 55.2908 9.09341 54.7414 9.58792C54.1644 10.0824 53.3128 10.3022 52.2139 10.3022H43.7523V19.6154H49.1919V14.5055H52.1589L55.6479 19.6154H61.4721L57.3238 13.5714ZM67.9136 19.6154V4.69781H62.007V0.384619H79.2323V4.69781H73.3532V19.6154H67.9136Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.253 20C129.22 20 127.38 19.5879 125.759 18.7088C124.138 17.8571 122.874 16.6758 121.94 15.1374C121.006 13.6264 120.566 11.9231 120.566 10C120.566 8.1044 121.006 6.4011 121.94 4.86264C122.874 3.35165 124.138 2.17033 125.759 1.29121C127.38 0.439559 129.22 0 131.253 0C133.286 0 135.099 0.439559 136.72 1.29121C138.341 2.17033 139.605 3.35165 140.539 4.86264C141.473 6.4011 141.94 8.1044 141.94 10C141.94 11.9231 141.473 13.6264 140.539 15.1374C139.605 16.6758 138.341 17.8571 136.72 18.7088C135.099 19.5879 133.286 20 131.253 20ZM131.253 15.4945C132.215 15.4945 133.094 15.2747 133.891 14.8077C134.66 14.3681 135.292 13.7088 135.759 12.8846C136.198 12.0604 136.446 11.0989 136.446 10C136.446 8.92857 136.198 7.96703 135.759 7.14285C135.292 6.31868 134.66 5.65934 133.891 5.19231C133.094 4.75275 132.215 4.50549 131.253 4.50549C130.264 4.50549 129.385 4.75275 128.616 5.19231C127.819 5.65934 127.187 6.31868 126.748 7.14285C126.281 7.96703 126.061 8.92857 126.061 10C126.061 11.0989 126.281 12.0604 126.748 12.8846C127.187 13.7088 127.819 14.3681 128.616 14.8077C129.385 15.2747 130.264 15.4945 131.253 15.4945ZM97.55 3.73627C96.8357 2.66484 95.8467 1.84066 94.583 1.26374C93.2918 0.686817 91.7808 0.384619 90.05 0.384619H81.2588V4.67033H89.7203C90.8192 4.67033 91.6709 4.91759 92.2478 5.41209C92.7973 5.9066 93.0995 6.62088 93.0995 7.5C93.0995 8.4066 92.7973 9.09341 92.2478 9.58792C91.6709 10.0824 90.8192 10.3022 89.7203 10.3022H81.2588V19.6154H86.6984V14.5879H90.05C91.7808 14.5879 93.2918 14.3132 94.583 13.7363C95.8467 13.1593 96.8357 12.3352 97.55 11.2637C98.2368 10.2198 98.594 8.95605 98.594 7.5C98.594 6.07143 98.2368 4.8077 97.55 3.73627ZM114.791 13.5714C115.972 12.9945 116.906 12.1978 117.565 11.1538C118.225 10.1099 118.554 8.9011 118.554 7.5C118.554 6.07143 118.197 4.8077 117.51 3.73627C116.796 2.66484 115.807 1.84066 114.543 1.26374C113.252 0.686817 111.741 0.384619 110.01 0.384619H101.219V4.67033H109.681C110.78 4.67033 111.631 4.91759 112.208 5.41209C112.758 5.9066 113.06 6.62088 113.06 7.5C113.06 8.4066 112.758 9.09341 112.208 9.58792C111.631 10.0824 110.78 10.3022 109.681 10.3022H101.219V19.6154H106.659V14.5055H109.626L113.115 19.6154H118.939L114.791 13.5714Z"
      fill="#C2D6FC"
    />
  </svg>
);
export const CustomIconFileUpload = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="83"
    height="68"
    viewBox="0 0 83 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.8086 33.4116C74.8086 42.0536 71.2788 49.8435 65.6189 55.4425C60.0808 60.9807 52.4125 64.3279 43.9531 64.3279C35.5546 64.3279 27.8864 60.9198 22.2874 55.4425C16.6275 49.8435 13.0977 42.0536 13.0977 33.4116C13.0977 16.3102 26.9126 2.49524 43.9531 2.49524C60.9936 2.49524 74.8086 16.3711 74.8086 33.4116Z"
      fill="#DBE2EB"
    />
    <path
      d="M78.005 21.6844C79.3831 21.6844 80.5002 20.5673 80.5002 19.1892C80.5002 17.8111 79.3831 16.694 78.005 16.694C76.6269 16.694 75.5098 17.8111 75.5098 19.1892C75.5098 20.5673 76.6269 21.6844 78.005 21.6844Z"
      fill="#DBE2EB"
    />
    <path
      d="M75.7822 3.4081C76.7233 3.4081 77.4862 2.64517 77.4862 1.70405C77.4862 0.762929 76.7233 0 75.7822 0C74.8411 0 74.0781 0.762929 74.0781 1.70405C74.0781 2.64517 74.8411 3.4081 75.7822 3.4081Z"
      fill="#DBE2EB"
    />
    <path
      d="M14.0712 13.0846C15.0124 13.0846 15.7753 12.3217 15.7753 11.3806C15.7753 10.4394 15.0124 9.67651 14.0712 9.67651C13.1301 9.67651 12.3672 10.4394 12.3672 11.3806C12.3672 12.3217 13.1301 13.0846 14.0712 13.0846Z"
      fill="#DBE2EB"
    />
    <path
      d="M3.66467 45.9485C5.41246 45.9485 6.82933 44.5316 6.82933 42.7838C6.82933 41.036 5.41246 39.6191 3.66467 39.6191C1.91687 39.6191 0.5 41.036 0.5 42.7838C0.5 44.5316 1.91687 45.9485 3.66467 45.9485Z"
      fill="#DBE2EB"
    />
    <path
      d="M67.3498 15.2106L64.8117 33.6466L61.6392 56.4267C60.8989 56.8505 60.0529 57.1684 59.2069 57.1684H22.6169C21.0306 57.1684 19.6558 56.6386 18.4926 55.791C18.1753 55.5791 17.8581 55.2612 17.5408 54.9434C16.2718 53.6719 15.4258 51.7647 15.4258 49.7516V10.3367C15.4258 8.53548 16.9063 7.15808 18.5983 7.15808H29.7022C30.4425 7.15808 31.1828 7.47594 31.8173 8.11167L35.4128 12.032C35.9416 12.5617 36.6818 12.8796 37.4221 12.8796H65.2347C66.5038 12.8796 67.4555 13.9391 67.3498 15.2106Z"
      fill="url(#paint0_linear)"
    />
    <g filter="url(#filter0_d)">
      <path
        d="M20.8184 53.1422L23.7794 18.919C23.8852 17.6476 24.9427 16.694 26.2117 16.694H68.3008C69.464 16.694 70.3101 17.6476 70.2043 18.8131L67.2433 47.9504L20.8184 53.1422Z"
        fill="url(#paint1_linear)"
      />
    </g>
    <g filter="url(#filter1_d)">
      <path
        d="M37.6331 49.4338L22.1934 53.0362L31.711 26.8655C32.134 25.7001 33.1915 24.9584 34.4605 24.9584H71.7908C73.1656 24.9584 74.1174 26.4417 73.4828 27.7132L63.3307 48.4802L37.6331 49.4338Z"
        fill="url(#paint2_linear)"
      />
    </g>
    <g filter="url(#filter2_d)">
      <path
        d="M77.0785 36.1894L62.9078 55.2612C62.5906 55.685 62.0618 56.1088 61.6388 56.4267C60.8985 56.8505 60.0525 57.1684 59.2065 57.1684H22.6165C21.0302 57.1684 19.6555 56.6386 18.4922 55.7909L31.2022 40.9646C32.532 39.4132 34.4734 38.5204 36.5167 38.5204H56.5627C57.6202 38.5204 58.6778 38.2026 59.5238 37.4609L63.5423 34.3882C63.9653 34.0704 64.3883 33.8585 64.8113 33.6466C65.3401 33.4346 65.9746 33.3287 66.5034 33.3287H75.598C77.0785 33.2227 77.9245 35.024 77.0785 36.1894Z"
        fill="url(#paint3_linear)"
      />
    </g>
    <path
      d="M53.9302 53.703C53.7216 54.5892 53.4088 55.5276 53.0439 56.3096C52.0534 58.2385 50.4894 59.7503 48.5606 60.7408C46.5795 61.7313 44.2336 62.1484 41.8876 61.6271C36.3616 60.4802 32.8166 55.0584 33.9635 49.5324C35.1105 44.0064 40.4801 40.4093 46.0061 41.6083C47.9871 42.0254 49.7075 43.0159 51.1672 44.3713C53.6174 46.8215 54.66 50.3665 53.9302 53.703Z"
      fill="white"
    />
    <g filter="url(#filter3_d)">
      <path
        d="M47.2041 50.7313H44.8582V48.3854C44.8582 47.9162 44.4933 47.4991 43.972 47.4991C43.5028 47.4991 43.0857 47.8641 43.0857 48.3854V50.7313H40.7398C40.2706 50.7313 39.8535 51.0963 39.8535 51.6176C39.8535 52.1389 40.2184 52.5038 40.7398 52.5038H43.0857V54.8498C43.0857 55.319 43.4506 55.736 43.972 55.736C44.4411 55.736 44.8582 55.3711 44.8582 54.8498V52.5038H47.2041C47.6733 52.5038 48.0904 52.1389 48.0904 51.6176C48.0904 51.0963 47.6733 50.7313 47.2041 50.7313Z"
        fill="url(#paint4_linear)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="6.81836"
        y="6.69397"
        width="69.3949"
        height="56.4482"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="8.19336"
        y="14.9584"
        width="71.4903"
        height="48.0778"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="3.49219"
        y="23.3242"
        width="78.9224"
        height="43.8441"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d"
        x="24.8535"
        y="37.4991"
        width="28.2369"
        height="28.2369"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="41.3959"
        y1="8.89538"
        x2="41.3959"
        y2="36.9657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="45.4997"
        y1="15.8509"
        x2="45.4997"
        y2="53.5351"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="47.9218"
        y1="24.3089"
        x2="47.9218"
        y2="53.3389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="47.9581"
        y1="34.1525"
        x2="47.9581"
        y2="47.536"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="43.9726"
        y1="47.7853"
        x2="43.9726"
        y2="52.4086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);
export const CustomIconSave = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 0H6V4H10V0Z" fill="var(--color-primary-500)" />
    <path
      d="M15 0H12V5C12 5.26522 11.8946 5.51957 11.7071 5.70711C11.5196 5.89464 11.2652 6 11 6H5C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16H15C15.2652 16 15.5196 15.8946 15.7071 15.7071C15.8946 15.5196 16 15.2652 16 15V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0ZM6 14H2V12H6V14Z"
      fill="#BFCCDA"
    />
  </svg>
);
export const CustomIconSaveOutline = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00037 7.40002C6.59512 7.40002 5.45593 8.53921 5.45593 9.94446C5.45593 11.3497 6.59512 12.4889 8.00037 12.4889C9.40563 12.4889 10.5448 11.3497 10.5448 9.94446C10.5448 8.53921 9.40563 7.40002 8.00037 7.40002ZM6.65593 9.94446C6.65593 9.20195 7.25786 8.60002 8.00037 8.60002C8.74288 8.60002 9.34481 9.20195 9.34481 9.94446C9.34481 10.687 8.74288 11.2889 8.00037 11.2889C7.25786 11.2889 6.65593 10.687 6.65593 9.94446Z"
      fill="#172A41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2453 0.400024H2.55603C1.98151 0.400024 1.43081 0.629395 1.02613 1.03711C0.621433 1.44484 0.396243 1.99729 0.400448 2.5717L0.48138 13.4606C0.490031 14.6448 1.45279 15.6002 2.63708 15.6L13.4448 15.6C14.0164 15.6 14.5648 15.3732 14.9692 14.9688C15.3736 14.5644 15.6004 14.016 15.6004 13.4444V4.75492C15.6002 4.18335 15.373 3.63523 14.9689 3.23108L12.7693 1.03154C12.3652 0.627188 11.817 0.400024 11.2453 0.400024ZM2.55603 1.60002C2.30139 1.60002 2.05725 1.70169 1.87782 1.88246C1.69843 2.0632 1.59857 2.30809 1.60042 2.56278L1.68135 13.4516C1.68516 13.9765 2.11183 14.4001 2.63675 14.4H13.4448C13.6985 14.4 13.9415 14.2993 14.1206 14.1202C14.2997 13.9411 14.4004 13.6981 14.4004 13.4444V4.75533C14.4003 4.50195 14.2995 4.25879 14.1204 4.07962L11.9208 1.88006C11.8566 1.81583 11.7842 1.76165 11.706 1.71859V4.11113C11.7057 4.87182 11.0891 5.48863 10.3285 5.4889L5.66159 5.4889C4.9009 5.48863 4.28409 4.87203 4.28381 4.11134V1.60002H2.55603ZM10.506 4.11091V1.60002H5.48381V4.11091C5.48385 4.2092 5.56352 4.28887 5.6618 4.2889H10.328C10.4263 4.28887 10.506 4.2092 10.506 4.11091Z"
      fill="#172A41"
    />
  </svg>
);
export const CustomIconReference = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00027 1.99961L2 4C2 4.55229 1.55228 5 1 5C0.447715 5 0 4.55229 0 4V2C0 1.73066 0.0537905 1.47136 0.152155 1.23416C0.257891 0.979178 0.456933 0.791168 0.693293 0.693293C0.791167 0.456933 0.979177 0.257891 1.23416 0.152155C1.47136 0.0537906 1.73066 0 2 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2L2.00027 1.99961ZM7 1C7 0.447715 7.44772 0 8 0H12C12.5523 0 13 0.447715 13 1C13 1.55228 12.5523 2 12 2H8C7.44772 2 7 1.55228 7 1ZM15 1C15 0.447715 15.4477 0 16 0H18C18.2693 0 18.5286 0.0537905 18.7658 0.152155C19.0208 0.257891 19.2088 0.456933 19.3067 0.693294C19.5431 0.791168 19.7421 0.979177 19.8478 1.23416C19.9462 1.47136 20 1.73066 20 2V4C20 4.55228 19.5523 5 19 5C18.4477 5 18 4.55228 18 4V2H16C15.4477 2 15 1.55228 15 1ZM19 7C19.5523 7 20 7.44772 20 8V12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12V8C18 7.44772 18.4477 7 19 7ZM1 7C1.55228 7 2 7.44772 2 8C2 8.55229 1.55228 9 1 9C0.447715 9 0 8.55229 0 8C0 7.44772 0.447715 7 1 7ZM19 15C19.5523 15 20 15.4477 20 16V18C20 18.2693 19.9462 18.5286 19.8478 18.7658C19.7421 19.0208 19.5431 19.2088 19.3067 19.3067C19.2088 19.5431 19.0208 19.7421 18.7658 19.8478C18.5286 19.9462 18.2693 20 18 20H16C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18H18V16C18 15.4477 18.4477 15 19 15ZM11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19Z"
      fill="#BFCCDA"
    />
    <path
      d="M0 11C0 10.4477 0.447715 10 1 10H9C9.55228 10 10 10.4477 10 11V19C10 19.5523 9.55228 20 9 20H1C0.447716 20 0 19.5523 0 19V11Z"
      fill="var(--color-primary-500)"
    />
  </svg>
);

export const CustomIconEquipment = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8744 10.0001C16.5869 10.0001 17.1306 10.3313 9.63061 4.88134C9.56413 4.83292 9.50783 4.77187 9.46494 4.70169C9.42205 4.63151 9.39341 4.55357 9.38064 4.47232C9.36787 4.39107 9.37123 4.3081 9.39053 4.22814C9.40983 4.14819 9.44468 4.07282 9.49311 4.00634C9.54153 3.93986 9.60258 3.88357 9.67276 3.84068C9.74294 3.79779 9.82088 3.76914 9.90213 3.75637C9.98338 3.7436 10.0664 3.74696 10.1463 3.76626C10.2263 3.78556 10.3016 3.82042 10.3681 3.86884L17.2431 8.86884C17.3502 8.9464 17.43 9.05596 17.4709 9.18174C17.5119 9.30752 17.5118 9.44304 17.4708 9.56879C17.4298 9.69455 17.35 9.80406 17.2428 9.88156C17.1356 9.95906 17.0066 10.0006 16.8744 10.0001Z"
      fill="var(--color-primary-500)"
    />
    <path
      d="M10.0001 6.25002C7.60013 6.25002 6.81263 3.12502 8.12513 3.12502C8.29089 3.12502 8.44986 3.19087 8.56707 3.30808C8.68428 3.42529 8.75013 3.58426 8.75013 3.75002C8.7521 3.96896 8.81153 4.18353 8.92249 4.37227C9.03345 4.56102 9.19204 4.7173 9.38238 4.82549C9.57272 4.93369 9.78814 4.98998 10.0071 4.98876C10.226 4.98753 10.4408 4.92882 10.6299 4.8185C10.819 4.70818 10.9759 4.55013 11.0847 4.36015C11.1935 4.17018 11.2506 3.95495 11.2501 3.73601C11.2496 3.51707 11.1916 3.30209 11.0819 3.1126C10.9723 2.92311 10.8147 2.76575 10.6251 2.65627C10.2563 2.47259 9.9448 2.19142 9.72445 1.84325C9.50409 1.49509 9.38328 1.09323 9.37513 0.681274C9.37513 0.515514 9.44097 0.356543 9.55818 0.239333C9.67539 0.122122 9.83437 0.0562744 10.0001 0.0562744C10.1659 0.0562744 10.3249 0.122122 10.4421 0.239333C10.5593 0.356543 10.6251 0.515514 10.6251 0.681274C10.6341 0.865992 10.6928 1.04485 10.7951 1.19889C10.8975 1.35294 11.0396 1.47643 11.2064 1.55627C11.6943 1.82291 12.0793 2.24456 12.3007 2.75456C12.5221 3.26456 12.5672 3.83381 12.4288 4.37229C12.2904 4.91077 11.9765 5.38776 11.5366 5.72783C11.0968 6.06791 10.5561 6.25165 10.0001 6.25002Z"
      fill="var(--color-primary-500)"
    />
    <path
      d="M3.12528 10.0001C2.99302 10.0006 2.86401 9.95906 2.75683 9.88156C2.64964 9.80406 2.56981 9.69455 2.52882 9.56879C2.48783 9.44304 2.48779 9.30752 2.52871 9.18174C2.56963 9.05596 2.6494 8.9464 2.75653 8.86884L9.63153 3.86884C9.69802 3.82042 9.77338 3.78556 9.85334 3.76626C9.93329 3.74696 10.0163 3.7436 10.0975 3.75637C10.1788 3.76914 10.2567 3.79779 10.3269 3.84068C10.3971 3.88357 10.4581 3.93986 10.5065 4.00634C10.555 4.07282 10.5898 4.14819 10.6091 4.22814C10.6284 4.3081 10.6318 4.39107 10.619 4.47232C10.6062 4.55357 10.5776 4.63151 10.5347 4.70169C10.4918 4.77187 10.4355 4.83292 10.369 4.88134C2.94403 10.2813 3.41903 10.0001 3.12528 10.0001Z"
      fill="var(--color-primary-500)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 19.75H2.25C1.91848 19.75 1.60054 19.6183 1.36612 19.3839C1.1317 19.1495 1 18.8315 1 18.5V17.25V9.75C1 9.41848 1.1317 9.10054 1.36612 8.86612C1.60054 8.6317 1.91848 8.5 2.25 8.5H17.25C17.5815 8.5 17.8995 8.6317 18.1339 8.86612C18.3683 9.10054 18.5 9.41848 18.5 9.75V18.5C18.5 18.8315 18.3683 19.1495 18.1339 19.3839C17.8995 19.6183 17.5815 19.75 17.25 19.75ZM5.18306 17.3169C5.30027 17.4342 5.45924 17.5 5.625 17.5C5.79076 17.5 5.94973 17.4342 6.06694 17.3169C6.18415 17.1997 6.25 17.0408 6.25 16.875V11.875C6.25 11.7092 6.18415 11.5503 6.06694 11.4331C5.94973 11.3158 5.79076 11.25 5.625 11.25C5.45924 11.25 5.30027 11.3158 5.18306 11.4331C5.06585 11.5503 5 11.7092 5 11.875V16.875C5 17.0408 5.06585 17.1997 5.18306 17.3169ZM9.55806 17.3169C9.67527 17.4342 9.83424 17.5 10 17.5C10.1658 17.5 10.3247 17.4342 10.4419 17.3169C10.5592 17.1997 10.625 17.0408 10.625 16.875V11.875C10.625 11.7092 10.5592 11.5503 10.4419 11.4331C10.3247 11.3158 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.3158 9.55806 11.4331C9.44085 11.5503 9.375 11.7092 9.375 11.875V16.875C9.375 17.0408 9.44085 17.1997 9.55806 17.3169ZM14.375 17.5C14.2092 17.5 14.0503 17.4342 13.9331 17.3169C13.8158 17.1997 13.75 17.0408 13.75 16.875V11.875C13.75 11.7092 13.8158 11.5503 13.9331 11.4331C14.0503 11.3158 14.2092 11.25 14.375 11.25C14.5408 11.25 14.6997 11.3158 14.8169 11.4331C14.9342 11.5503 15 11.7092 15 11.875V16.875C15 17.0408 14.9342 17.1997 14.8169 17.3169C14.6997 17.4342 14.5408 17.5 14.375 17.5Z"
      fill="#BFCCDA"
    />
  </svg>
);

export const CustomIconTruck = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0049 16.4277H7.34375"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0095 11.0054H17.508C17.2318 11.0054 17.0078 10.7815 17.0078 10.5052V7.00375H20.5091"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5656 15.4466C17.9948 15.8757 18.1232 16.5212 17.891 17.0819C17.6588 17.6427 17.1116 18.0083 16.5046 18.0083C15.8977 18.0083 15.3505 17.6428 15.1182 17.082C14.8859 16.5213 15.0143 15.8759 15.4434 15.4467L15.4435 15.4465C16.0295 14.8606 16.9796 14.8606 17.5656 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 2.00167H9.00333"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00391 2.00166C9.55642 2.00166 10.0043 2.44956 10.0043 3.00208"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0041 3.00209V9.00459"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.56172 15.4466C3.99092 15.8757 4.11933 16.5211 3.88709 17.0819C3.65485 17.6427 3.10769 18.0083 2.50074 18.0083C1.89379 18.0083 1.34659 17.6428 1.1143 17.082C0.882005 16.5213 1.01036 15.8758 1.43952 15.4467L1.43982 15.4464C1.72121 15.165 2.10286 15.0069 2.5008 15.0069C2.89874 15.007 3.28036 15.1651 3.5617 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.7375 15.4466C7.1667 15.8757 7.29512 16.5211 7.06287 17.0819C6.83063 17.6427 6.28347 18.0083 5.67652 18.0083C5.06957 18.0083 4.52238 17.6428 4.29008 17.082C4.05779 16.5213 4.18614 15.8758 4.6153 15.4467L4.6156 15.4464C4.89699 15.165 5.27864 15.0069 5.67658 15.0069C6.07452 15.007 6.45614 15.1651 6.73748 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0011 16.5077H20.0068C20.5593 16.5077 21.0072 16.0598 21.0072 15.5073V8.47665C21.0072 8.16593 20.9349 7.85949 20.7959 7.5816L19.5588 5.1083C19.2199 4.43058 18.5271 4.0025 17.7693 4.0025H13.0039"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 12.0058H13.005V2.00166"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconBilling = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0023 8.99958H17.0031C18.1847 8.91566 19.0778 7.89491 19.004 6.71263V3.2832C19.0778 2.10092 18.1847 1.08017 17.0031 0.996246H2.99729C1.81568 1.08017 0.922633 2.10092 0.996453 3.2832V6.71363C0.922648 7.89572 1.81583 8.91618 2.99729 8.99958H4.99812"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3365 17.0029L11.6698 18.0033L10.0021 17.0029L8.33439 18.0033L6.66769 17.0029L5 18.0033V4.99792H15.0042V18.0033L13.3365 17.0029Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14.0017H12.0017"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7513 9.01257L9.73141 11.0314L8.75 10.053"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconMapMarker = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6569 3.35098V3.35098C18.7811 6.48993 18.7811 11.5636 15.6569 14.7025V14.7025L12.345 18.0254C11.056 19.3205 8.96113 19.3254 7.666 18.0364L7.655 18.0254L4.34313 14.7025C1.21898 11.5635 1.21895 6.48998 4.34307 3.35098V3.35098C7.45255 0.226779 12.5059 0.214847 15.6301 3.32433L15.6568 3.35098H15.6569Z"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 8.62875V11C13 11.5523 12.5523 12 12 12H8C7.44772 12 7 11.5523 7 11V8.57113C7 8.26734 7.1381 7.98002 7.37532 7.79025L9.33932 6.21912C9.70453 5.92696 10.2235 5.92696 10.5887 6.21912L12.6247 7.84787C12.8619 8.03764 13 8.32496 13 8.62875Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CustomIconBuilding = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.5V7"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10V8C7.5 7.44772 7.94772 7 8.5 7H11.5C12.0523 7 12.5 7.44772 12.5 8V10"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 18.8997V11C5 10.4477 5.44772 10 6 10H14C14.5523 10 15 10.4477 15 11V18.8997"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="5"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 13H12.5"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16H12.5"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconDonoutChart = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="15" stroke="#DBE2EB" strokeWidth="5" />
    <path
      d="M31.1652 25.1887C32.4126 22.9043 33.0441 20.3346 32.9976 17.7323C32.9512 15.1299 32.2284 12.5844 30.9002 10.346C29.5721 8.10753 27.6844 6.25317 25.4226 4.96521C23.1608 3.67725 20.6028 3 18 3"
      stroke="var(--color-primary-500)"
      strokeWidth="5"
    />
  </svg>
);

export const CustomIconAddUser = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <circle cx="15" cy="15.5" r="15" fill="#DBE2EB" />
      <path
        d="M15.1273 9.1618C16.0097 10.0442 16.0097 11.4749 15.1273 12.3573C14.2449 13.2397 12.8142 13.2397 11.9318 12.3573C11.0494 11.4749 11.0494 10.0442 11.9318 9.1618C12.8142 8.2794 14.2449 8.2794 15.1273 9.1618"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.705 19.5H9.55926C9.25055 19.5 9 19.2098 9 18.8522V18.2044C9 16.2448 11.2102 14.9706 13.474 14.9706C13.9323 14.9706 14.388 15.023 14.8235 15.1228"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 25.5C16.239 25.5 14 23.262 14 20.5C14 17.796 16.3 15.497 19.004 15.5C21.764 15.502 24 17.74 24 20.5C24 23.261 21.762 25.5 19 25.5Z"
        fill="var(--color-primary-500)"
      />
      <path
        d="M19 18.5V22.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21 20.5H17"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CustomIconNotes = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0003 8.99955H17.0012C18.1828 8.91563 19.0758 7.89487 19.002 6.7126V3.28317C19.0758 2.10089 18.1828 1.08013 17.0012 0.996216H2.99533C1.81373 1.08013 0.92068 2.10089 0.9945 3.28317V6.7136C0.920695 7.89569 1.81388 8.91615 2.99533 8.99955H4.99617"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3326 17.0029L11.6659 18.0033L9.99818 17.0029L8.33048 18.0033L6.66379 17.0029L4.99609 18.0033V4.99792H15.0003V18.0033L13.3326 17.0029Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99805 14.0017H11.9997"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7493 9.01257L9.72946 11.0314L8.74805 10.053"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconAlert = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="50"
    height="41"
    viewBox="0 0 50 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.828345 33.4867L20.5954 2.2016C22.7469 -0.733866 27.2517 -0.733866 29.4032 2.2016L49.1703 33.4867C51.2546 36.2917 49.1703 40.2709 45.6068 40.2709H4.45903C0.828345 40.2056 -1.25594 36.2917 0.828345 33.4867Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M24.9995 10.2109C23.1159 10.2109 21.6509 11.8668 21.7904 13.8106L22.8369 25.4734C22.9066 26.6253 23.8833 27.5612 24.9995 27.5612C26.1157 27.5612 27.0924 26.6253 27.1621 25.4734L28.2086 13.8106C28.3481 11.7948 26.8831 10.2109 24.9995 10.2109Z"
      fill="white"
    />
    <path
      d="M24.9997 29.7209C23.6045 29.7209 22.4883 30.8728 22.4883 32.3127C22.4883 33.7525 23.6045 34.9044 24.9997 34.9044C26.395 34.9044 27.5112 33.7525 27.5112 32.3127C27.5112 30.8728 26.395 29.7209 24.9997 29.7209Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-0.0228992"
        y1="21.1943"
        x2="50.0091"
        y2="21.1943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconMessage = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="132"
    height="132"
    viewBox="0 0 132 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.4282 109.689C96.9016 109.689 119.175 87.4162 119.175 59.8446C119.175 32.2731 96.9016 10 69.4282 10C41.9547 10 19.6816 32.2731 19.6816 59.8446C19.6816 87.4162 41.9547 109.689 69.4282 109.689Z"
      fill="#EAEEF9"
    />
    <path
      d="M124.866 44.2435C127.087 44.2435 128.889 42.4424 128.889 40.2206C128.889 37.9989 127.087 36.1978 124.866 36.1978C122.644 36.1978 120.843 37.9989 120.843 40.2206C120.843 42.4424 122.644 44.2435 124.866 44.2435Z"
      fill="#EAEEF9"
    />
    <path
      d="M108.247 21.4947C109.765 21.4947 110.995 20.2647 110.995 18.7473C110.995 17.23 109.765 16 108.247 16C106.73 16 105.5 17.23 105.5 18.7473C105.5 20.2647 106.73 21.4947 108.247 21.4947Z"
      fill="#EAEEF9"
    />
    <path
      d="M16.2473 47.0889C17.7647 47.0889 18.9947 45.8589 18.9947 44.3416C18.9947 42.8243 17.7647 41.5942 16.2473 41.5942C14.73 41.5942 13.5 42.8243 13.5 44.3416C13.5 45.8589 14.73 47.0889 16.2473 47.0889Z"
      fill="#EAEEF9"
    />
    <path
      d="M86.5002 31.0396C103.438 31.0396 117.102 43.3579 117.102 58.5015C117.102 67.2035 112.585 75.0013 105.471 80.0869V91.5011C105.471 93.0833 103.664 93.8744 102.535 92.9703L92.8237 85.3985C90.7911 85.7375 88.7586 85.9635 86.6131 85.9635C69.6751 85.9635 56.0117 73.6452 56.0117 58.5015C56.0117 43.3579 69.6751 31.0396 86.5002 31.0396Z"
      fill="#CBD4E0"
    />
    <g filter="url(#filter0_d)">
      <path
        d="M56.5765 29.6836C37.7188 29.6836 22.4746 43.3581 22.4746 60.1969C22.4746 69.916 27.556 78.6179 35.4604 84.1555V96.8129C35.4604 98.5081 37.3801 99.5252 38.7351 98.3951L49.5754 90.0322C51.8338 90.4842 54.0922 90.7102 56.4636 90.7102C75.3212 90.7102 90.5654 77.0357 90.5654 60.1969C90.5654 43.3581 75.3212 29.6836 56.5765 29.6836Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.474609"
        y="18.6836"
        width="112.091"
        height="113.189"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="56.4978"
        y1="28.0832"
        x2="56.4978"
        y2="99.6183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconUploadDocument = ({ className }) => (
  <svg
    width="128"
    height="127"
    viewBox="0 0 128 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.8502 107.5C93.5502 107.5 117.75 83.4 117.75 53.8C117.65 24.1 93.5502 0 63.8502 0C34.0502 0 9.9502 24.1 9.9502 53.7C9.9502 83.4 34.0502 107.5 63.8502 107.5Z"
      fill="#EAEEF9"
    />
    <path
      d="M119.05 35C121.315 35 123.15 33.1644 123.15 30.9C123.15 28.6357 121.315 26.8 119.05 26.8C116.786 26.8 114.95 28.6357 114.95 30.9C114.95 33.1644 116.786 35 119.05 35Z"
      fill="#EAEEF9"
    />
    <path
      d="M125.05 18.9999C126.596 18.9999 127.85 17.7463 127.85 16.1999C127.85 14.6535 126.596 13.3999 125.05 13.3999C123.504 13.3999 122.25 14.6535 122.25 16.1999C122.25 17.7463 123.504 18.9999 125.05 18.9999Z"
      fill="#EAEEF9"
    />
    <path
      d="M5.35039 89.7999C8.22227 89.7999 10.5504 87.4718 10.5504 84.5999C10.5504 81.728 8.22227 79.3999 5.35039 79.3999C2.47851 79.3999 0.150391 81.728 0.150391 84.5999C0.150391 87.4718 2.47851 89.7999 5.35039 89.7999Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_3966:351255)">
      <path
        d="M93.1879 34.4448L93.8855 90.5993C93.8855 92.5177 92.316 94 90.3976 94H35.6382C33.7199 94 32.1504 92.4305 32.1504 90.5993V18.4007C32.1504 16.4823 33.7199 15 35.6382 15H75.3126L93.1879 34.4448Z"
        fill="url(#paint0_linear_3966:351255)"
      />
    </g>
    <path
      d="M58.3383 82H57.2164C56.9725 82 56.7773 81.7727 56.7773 81.5C56.7773 81.2273 56.9725 81 57.2164 81H58.3383C58.5822 81 58.7773 81.2273 58.7773 81.5C58.7773 81.8182 58.5822 82 58.3383 82Z"
      fill="#CED7E2"
    />
    <path
      d="M52.0668 82H41.4879C41.0931 82 40.7773 81.7727 40.7773 81.5C40.7773 81.2273 41.0931 81 41.4879 81H52.0668C52.4616 81 52.7773 81.2273 52.7773 81.5C52.7773 81.8182 52.4616 82 52.0668 82Z"
      fill="#D5DDEA"
    />
    <path
      d="M67.6642 27H41.8905C41.2911 27 40.7773 26.5385 40.7773 26C40.7773 25.4615 41.2911 25 41.8905 25H67.6642C68.2636 25 68.7773 25.4615 68.7773 26C68.7773 26.5385 68.2636 27 67.6642 27Z"
      fill="#D5DDEA"
    />
    <path
      d="M51.7561 33H41.8837C41.288 33 40.7773 32.5385 40.7773 32C40.7773 31.4615 41.288 31 41.8837 31H51.671C52.2667 31 52.7773 31.4615 52.7773 32C52.7773 32.5385 52.2667 33 51.7561 33Z"
      fill="#D5DDEA"
    />
    <path
      d="M75.5234 15V30.9641C75.5234 33.2063 77.4551 35 79.6503 35L93.1503 34.5"
      fill="#D5DDEA"
    />
    <path
      d="M54.0473 43.514C56.5767 41.8926 59.5601 40.9846 62.7381 40.9846C71.4289 40.9846 78.4983 47.9892 78.4983 56.68C78.4983 65.3708 71.4289 72.3753 62.7381 72.3753C54.0473 72.3753 46.9779 65.3708 46.9779 56.68C46.8482 51.1671 49.7019 46.3677 54.0473 43.514Z"
      fill="url(#paint1_linear_3966:351255)"
    />
    <path
      d="M63.8713 49.5072L68.3796 54.4348C68.9099 55.0145 68.9099 56.029 68.3796 56.6087C67.8492 57.1884 66.921 57.1884 66.3243 56.6087L64.2691 54.4348V62.4058C64.2691 63.2754 63.6061 64 62.8105 64C62.0149 64 61.3519 63.2754 61.3519 62.4058V54.4348L59.2967 56.6087C58.7663 57.1884 57.8381 57.1884 57.2414 56.6087C56.9099 56.2464 56.7773 55.8841 56.7773 55.5217C56.7773 55.1594 56.9099 54.6522 57.2414 54.4348L61.7497 49.5072C61.9486 49.2899 62.4127 49 62.7442 49C63.0757 49 63.6724 49.1449 63.8713 49.5072Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_3966:351255"
        x="10.1504"
        y="4"
        width="105.735"
        height="123"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3966:351255"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3966:351255"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3966:351255"
        x1="62.9978"
        y1="13.1727"
        x2="62.9978"
        y2="94.8517"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3966:351255"
        x1="62.7385"
        y1="42.0751"
        x2="62.7385"
        y2="59.6944"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIcon404_1 = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    viewBox="0 0 817 252"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".5"
      d="M816.35 251.184H.373c22.053-19.765 54.285-39.53 91.607-54.353 20.357-7.412 44.106-17.294 67.856-22.235 71.25-19.765 157.767-32.118 249.374-32.118 110.267 0 212.052 17.294 290.087 44.471 27.143 9.882 50.893 19.764 71.25 32.117 18.66 9.883 33.928 19.765 45.803 32.118Z"
      fill="url(#a)"
    />
    <path
      opacity=".3"
      d="M171.133 186.547c1.069 10.035-16.418 22.046-36.661 24.202-20.242 2.156-38.002-4.409-40.757-14.264 19.708-7.174 42.611-16.379 65.871-22.239 7.104 2.626 11.012 7.284 11.547 12.301Z"
      fill="url(#b)"
    />
    <path
      opacity=".3"
      d="M314.2 179.478c27.17 0 49.196-5.271 49.196-11.773s-22.026-11.773-49.196-11.773c-27.17 0-49.196 5.271-49.196 11.773s22.026 11.773 49.196 11.773Z"
      fill="url(#c)"
    />
    <path
      opacity=".3"
      d="M579.383 178.513c.557-8.342-20.968-16.548-48.079-18.329-27.11-1.782-49.539 3.536-50.097 11.878-.558 8.342 20.968 16.548 48.078 18.329 27.111 1.782 49.54-3.537 50.098-11.878Z"
      fill="url(#d)"
    />
    <path
      opacity=".3"
      d="M766.157 216.412c-6.741-.777-14.836-.517-24.754-3.354-26.772-4.78-47.717-15.661-46.753-24.015.192-1.671.192-1.671 2.07-3.147 26.194 9.793 50.002 19.264 69.437 30.516Z"
      fill="url(#e)"
    />
    <path
      d="M292.16 116.05v33.638h-20.357v31.956h-39.017v-31.956h-84.821v-38.683L226 3.363h45.803V116.05h20.357Zm-57.678-68.957-49.196 68.957h49.196V47.093Z"
      fill="url(#f)"
    />
    <path
      d="M414.302 185.009c-40.714 0-76.339-35.32-76.339-92.505C337.963 35.32 373.588 0 414.302 0s76.339 35.32 76.339 92.504c1.696 55.503-33.929 92.505-76.339 92.505Zm0-35.32c18.66 0 39.017-18.501 39.017-58.867 0-38.683-18.66-58.866-39.017-58.866-18.661 0-39.018 18.5-39.018 58.866 1.697 40.366 20.357 58.867 39.018 58.867Z"
      fill="url(#g)"
    />
    <path
      d="M684.029 116.05v33.638h-20.357v31.956h-39.017v-31.956h-84.821v-38.683L617.869 3.363h44.107V116.05h22.053Zm-59.374-68.957-49.196 68.957h49.196V47.093Z"
      fill="url(#h)"
    />
    <path
      d="M276.881 116.051v33.637h-20.357v31.957h-39.018v-31.957h-84.82v-38.683L210.721 3.364h44.107V116.05h22.053Zm-57.678-68.958-49.196 68.958h49.196V47.093Z"
      fill="url(#i)"
    />
    <path
      d="M399.022 185.009c-40.714 0-76.338-35.32-76.338-92.505C322.684 35.32 358.308 0 399.022 0c40.714 0 76.339 35.32 76.339 92.504 1.697 55.503-33.928 92.505-76.339 92.505Zm0-35.32c18.661 0 39.018-18.501 39.018-58.866 0-38.684-18.661-58.867-39.018-58.867-18.66 0-39.017 18.501-39.017 58.867 1.696 40.365 20.357 58.866 39.017 58.866Z"
      fill="url(#j)"
    />
    <path
      d="M668.75 116.051v33.637h-20.357v31.957h-39.017v-31.957h-84.821v-38.683L602.59 3.364h44.107V116.05h22.053Zm-59.374-68.958-49.197 68.958h49.197V47.093Z"
      fill="url(#k)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="408.362"
        y1="142.478"
        x2="408.362"
        y2="251.184"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B6BFD7" />
        <stop offset="1" stopColor="#838DA7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="131.039"
        y1="178.462"
        x2="133.039"
        y2="197.236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="314.208"
        y1="156.75"
        x2="314.208"
        y2="169.966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="484.618"
        y1="172.284"
        x2="539.718"
        y2="175.967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="732.027"
        y1="190.758"
        x2="730.572"
        y2="203.367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="220.074"
        y1="9.557"
        x2="220.074"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6DCE6" />
        <stop offset="1" stopColor="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="414.343"
        y1="6.427"
        x2="414.343"
        y2="110.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6DCE6" />
        <stop offset="1" stopColor="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="611.943"
        y1="9.557"
        x2="611.943"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6DCE6" />
        <stop offset="1" stopColor="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="204.795"
        y1="9.557"
        x2="204.795"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEEF5" />
        <stop offset="1" stopColor="#D4DAE4" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="399.064"
        y1="6.427"
        x2="399.064"
        y2="110.271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEEF5" />
        <stop offset="1" stopColor="#D4DAE4" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="596.664"
        y1="9.557"
        x2="596.664"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEEF5" />
        <stop offset="1" stopColor="#D4DAE4" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconTruckMaintain = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    viewBox="0 0 239 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78.01 128.376c-9.159 0-16.584-8.258-16.584-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.426 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M75.058 121.244h2.954v7.132h-2.954v-7.132ZM204.333 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path d="M199.329 117.309h4.771v11.067h-4.771v-11.067Z" fill="#1C3754" />
    <path
      d="M14.172 7.624v79.19H170.48V12.297C170.48 5.41 165.482 0 159.121 0H21.215c-3.862 0-7.043 3.443-7.043 7.624Z"
      fill="url(#a)"
    />
    <path
      opacity=".7"
      d="M120.042 26.315h20.901v65.172h-20.901V26.315Z"
      fill="url(#b)"
    />
    <path
      d="M.087 7.624v79.19h120.866V12.297C120.953 5.41 115.955 0 109.593 0H7.13C3.267 0 .087 3.443.087 7.624Z"
      fill="#EAEEF9"
    />
    <path
      d="M.087 7.624v79.19h120.866V12.297C120.953 5.41 115.955 0 109.593 0H7.13C3.267 0 .087 3.443.087 7.624Z"
      fill="url(#c)"
    />
    <path
      d="M74.833 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444ZM199.106 128.376c-9.159 0-16.585-8.258-16.585-18.444 0-10.187 7.426-18.445 16.585-18.445 9.16 0 16.585 8.258 16.585 18.445 0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#112133"
    />
    <path
      d="M55.52 86.568v23.609h179.709c1.817 0 3.408-1.721 3.408-3.689V78.944c0-3.935-1.136-7.624-3.181-10.82L206.83 22.38h-59.752l27.263 64.188H55.519Z"
      fill="#EAEEF9"
    />
    <path
      d="M.085 86.568v23.609h193.341V79.682c0-4.427-1.136-8.854-3.635-12.543l-26.355-42.054c-1.136-1.721-2.953-2.951-4.998-2.951h-25.9c-1.363 0-2.272.984-2.272 2.46v61.974H.085Z"
      fill="#CAD1E0"
    />
    <path
      opacity=".4"
      d="M52.793 86.568h39.531v19.92H52.793v-19.92Z"
      fill="url(#d)"
    />
    <path
      d="M15.08 106.488c1.362-10.083 9.314-17.953 18.856-17.953 9.542 0 17.494 7.87 18.857 17.953h86.333c1.591-10.083 9.542-17.953 19.312-17.953 9.769 0 17.948 7.87 19.311 17.953h60.888v.246c0 1.968-1.591 3.689-3.408 3.689H.312v-3.689h14.767v-.246Z"
      fill="#ACB7CF"
    />
    <path
      d="M233.64 92.224c-1.757 0-3.181-2.642-3.181-5.902 0-3.26 1.424-5.902 3.181-5.902 1.756 0 3.18 2.642 3.18 5.902 0 3.26-1.424 5.902-3.18 5.902ZM202.056 92.224c-1.757 0-3.181-2.642-3.181-5.902 0-3.26 1.424-5.902 3.181-5.902 1.756 0 3.18 2.642 3.18 5.902 0 3.26-1.424 5.902-3.18 5.902Z"
      fill="#4C5463"
    />
    <path
      d="M210.693 101.324h14.995c1.59 0 2.726-1.476 2.726-2.951V84.355c0-1.722-1.363-2.952-2.726-2.952h-14.995c-1.59 0-2.726 1.476-2.726 2.952v14.018c0 1.721 1.136 2.951 2.726 2.951Z"
      fill="#CAD1E0"
    />
    <path
      d="m168.435 27.052 9.542 15.002 6.816 10.821 8.633 13.28h36.578l-3.862-5.902-3.181-4.918-3.181-4.919-6.361-9.837-8.633-13.527h-36.351ZM134.583 29.266v36.89h48.392l-23.174-37.628a1.24 1.24 0 0 0-1.136-.738h-22.719c-.682 0-1.363.738-1.363 1.476Z"
      fill="#fff"
    />
    <path
      d="M141.171 75.747h-5.452c-.455 0-.909-.492-.909-.984s.454-.984.909-.984h5.452c.455 0 .909.492.909.984 0 .738-.454.984-.909.984Z"
      fill="#4C5463"
    />
    <path
      d="M145.489 110.177c.228 10.084 7.725 18.199 17.04 18.199s16.812-8.115 17.039-18.199h-34.079Z"
      fill="#112133"
    />
    <path d="M157.983 111.653h4.544v16.969h-4.544v-16.969Z" fill="#112133" />
    <path
      d="M158.666 128.376c-9.411 0-17.04-8.258-17.04-18.444 0-10.187 7.629-18.445 17.04-18.445 9.41 0 17.039 8.258 17.039 18.445 0 10.186-7.629 18.444-17.039 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M158.667 118.539c-4.391 0-7.951-3.854-7.951-8.608 0-4.753 3.56-8.607 7.951-8.607 4.392 0 7.952 3.854 7.952 8.607 0 4.754-3.56 8.608-7.952 8.608ZM21.666 110.177c.227 10.084 7.497 18.199 16.585 18.199 9.088 0 16.358-8.115 16.585-18.199h-33.17Z"
      fill="#112133"
    />
    <path d="M34.163 120.753h4.089v7.623h-4.09v-7.623Z" fill="#112133" />
    <path
      d="M34.163 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M34.164 118.539c-4.266 0-7.724-3.854-7.724-8.608 0-4.753 3.458-8.607 7.724-8.607s7.725 3.854 7.725 8.607c0 4.754-3.459 8.608-7.725 8.608Z"
      fill="#112133"
    />
    <path d="M88.918 94.438h45.666v7.132H88.918v-7.132Z" fill="#DAE1ED" />
    <path d="M89.826 101.324h43.848v29.266H89.826v-29.266Z" fill="#DAE1ED" />
    <path
      d="M120.498 94.438v36.152h13.177v-29.266h.909v-6.886h-14.086Z"
      fill="#fff"
    />
    <path
      opacity=".4"
      d="M105.276 94.438h4.089v36.152h-4.089V94.438Z"
      fill="#fff"
    />
    <path
      opacity=".15"
      d="M88.918 94.438v6.886h.91v5.41l8.632-4.426 1.591-.984 5.225-2.705 4.09-1.968 2.499-1.475 1.59-.738H88.918Z"
      fill="#4C5463"
    />
    <path d="M89.826 101.324h43.848v.734H89.826v-.734Z" fill="#ACB7CF" />
    <path
      d="M80.739 58.04h45.665v7.132H80.739V58.04ZM81.873 65.172h43.848v29.266H81.872V65.172Z"
      fill="#DAE1ED"
    />
    <path
      d="M112.318 58.04v36.398h13.405V65.172h.681V58.04h-14.086Z"
      fill="#fff"
    />
    <path opacity=".4" d="M97.1 58.04h4.089v36.152H97.1V58.04Z" fill="#fff" />
    <path d="M81.873 65.172h43.848v.734H81.872v-.734Z" fill="#ACB7CF" />
    <path
      d="M86.189 42.546c1.59 1.476 2.045 3.935.682 5.903l-.682.737L68.014 64.68c-1.59 1.476-3.863.984-5.226-.738-.454-.737-.681-1.475-.681-2.459v-5.902H25.756c-.682 0-1.136-.492-1.136-1.23V37.628c0-.738.454-1.23 1.136-1.23h36.35v-5.902c0-2.214 1.591-3.935 3.636-3.935.908 0 1.59.246 2.272.738l18.175 15.247Z"
      fill="url(#e)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="98.207"
        y1="-1.164"
        x2="88.5"
        y2="67.122"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83A6FF" />
        <stop offset="1" stopColor="#5A78FF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="130.425"
        y1="26.206"
        x2="130.425"
        y2="91.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".003" stopColor="#0F2F73" stopOpacity="0" />
        <stop offset="1" stopColor="#0A1D47" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="-2.495"
        y1="70.466"
        x2="133.848"
        y2="22.408"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83A6FF" />
        <stop offset="1" stopColor="#5A78FF" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="63.841"
        y1="96.924"
        x2="100.348"
        y2="95.727"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".003" stopColor="#0F2F73" stopOpacity="0" />
        <stop offset="1" stopColor="#0A1D47" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="87.755"
        y1="45.88"
        x2="24.467"
        y2="45.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconConfirm = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="27" fill="#367BF6" />
    <path
      fillRule="evenodd"
      clip-rule="evenodd"
      d="M44.2582 22.9754L26.4948 43.2764L15.9824 33.7197L20.0185 29.2801L26.0061 34.7234L39.7427 19.0244L44.2582 22.9754Z"
      fill="white"
    />
  </svg>
);

export const CustomIconInvoiceProcessing = ({ className }) => (
  <svg
    width="153"
    height="120"
    viewBox="0 0 153 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76.859 110.018C104.768 110.018 127.509 87.3712 127.509 59.556C127.415 31.6468 104.768 9 76.859 9C48.8558 9 26.209 31.6468 26.209 59.462C26.209 87.3712 48.8558 110.018 76.859 110.018Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_12391_232104)">
      <path
        d="M130.892 65.9458C130.892 76.7524 122.152 85.4916 111.252 85.4916C111.064 85.4916 109.466 85.4916 97.7201 85.4916C89.5446 85.4916 76.4828 85.4916 55.6214 85.4916H45.6605C32.5987 85.7735 22.168 75.3428 22.168 62.7508C22.168 50.0648 32.6926 39.5402 45.9424 40.198C57.3128 4.6772 109.372 9.65762 113.789 46.4C123.562 47.6216 130.892 55.891 130.892 65.9458Z"
        fill="url(#paint0_linear_12391_232104)"
      />
    </g>
    <path
      d="M111.253 85.492C122.06 85.492 130.893 76.7528 130.893 65.9462C130.893 55.1396 122.06 46.4004 111.253 46.4004C100.446 46.4004 91.6133 55.1396 91.6133 65.9462C91.6133 76.7528 100.446 85.492 111.253 85.492Z"
      fill="url(#paint1_linear_12391_232104)"
    />
    <path
      d="M79.2089 85.6795C98.4728 85.6795 114.166 70.0805 114.166 50.8166C114.166 31.5527 98.4728 15.9536 79.2089 15.9536C59.945 15.9536 44.252 31.5527 44.252 50.8166C44.252 70.0805 59.851 85.6795 79.2089 85.6795Z"
      fill="url(#paint2_linear_12391_232104)"
    />
    <path
      d="M60.4631 51.8347C65.2772 48.7355 70.9555 47 77.004 47C93.545 47 107 60.3884 107 77C107 93.6116 93.545 107 77.004 107C60.4631 107 47.0081 93.6116 47.0081 77C46.7612 66.4628 52.1926 57.2893 60.4631 51.8347Z"
      fill="url(#paint3_linear_12391_232104)"
    />
    <path
      d="M74.9945 90.1208L66.7293 81.5797C65.7569 80.5749 65.7569 78.8164 66.7293 77.8116C67.7017 76.8068 69.4033 76.8068 70.4972 77.8116L74.2652 81.5797L74.2652 67.7633C74.2652 66.256 75.4807 65 76.9392 65C78.3978 65 79.6133 66.256 79.6133 67.7633L79.6133 81.5797L83.3812 77.8116C84.3536 76.8068 86.0552 76.8068 87.1492 77.8116C87.7569 78.4396 88 79.0676 88 79.6957C88 80.3237 87.7569 81.2029 87.1492 81.5797L78.884 90.1208C78.5193 90.4976 77.6685 91 77.0608 91C76.453 91 75.3591 90.7488 74.9945 90.1208Z"
      fill="white"
    />
    <path
      d="M128.73 41.8896C130.858 41.8896 132.583 40.1647 132.583 38.0369C132.583 35.909 130.858 34.1841 128.73 34.1841C126.602 34.1841 124.877 35.909 124.877 38.0369C124.877 40.1647 126.602 41.8896 128.73 41.8896Z"
      fill="#EAEEF9"
    />
    <path
      d="M134.369 26.8541C135.823 26.8541 137.001 25.6761 137.001 24.223C137.001 22.7698 135.823 21.5918 134.369 21.5918C132.916 21.5918 131.738 22.7698 131.738 24.223C131.738 25.6761 132.916 26.8541 134.369 26.8541Z"
      fill="#EAEEF9"
    />
    <path
      d="M27.8069 35.4996C29.2601 35.4996 30.4381 34.3216 30.4381 32.8685C30.4381 31.4153 29.2601 30.2373 27.8069 30.2373C26.3538 30.2373 25.1758 31.4153 25.1758 32.8685C25.1758 34.3216 26.3538 35.4996 27.8069 35.4996Z"
      fill="#EAEEF9"
    />
    <path
      d="M21.8865 93.3852C24.5852 93.3852 26.7729 91.1975 26.7729 88.4988C26.7729 85.8 24.5852 83.6123 21.8865 83.6123C19.1877 83.6123 17 85.8 17 88.4988C17 91.1975 19.1877 93.3852 21.8865 93.3852Z"
      fill="#EAEEF9"
    />
    <defs>
      <filter
        id="filter0_d_12391_232104"
        x="0.167969"
        y="5.03857"
        width="152.723"
        height="113.458"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12391_232104"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12391_232104"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_12391_232104"
        x1="76.5298"
        y1="44.7416"
        x2="76.4943"
        y2="86.246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12391_232104"
        x1="89.5233"
        y1="42.1922"
        x2="106.934"
        y2="61.2341"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset="0.9942" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12391_232104"
        x1="40.9786"
        y1="34.8189"
        x2="68.4191"
        y2="45.5572"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset="0.9942" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12391_232104"
        x1="77.0047"
        y1="49.0843"
        x2="77.0047"
        y2="82.7617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconRedAlert = ({ className }) => (
  <svg
    className={`cicon ${className}`}
    width="50"
    height="41"
    viewBox="0 0 50 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.828345 33.4867L20.5954 2.2016C22.7469 -0.733866 27.2517 -0.733866 29.4032 2.2016L49.1703 33.4867C51.2546 36.2917 49.1703 40.2709 45.6068 40.2709H4.45903C0.828345 40.2056 -1.25594 36.2917 0.828345 33.4867Z"
      fill="#EB4E3D"
    />
    <path
      d="M24.9995 10.2109C23.1159 10.2109 21.6509 11.8668 21.7904 13.8106L22.8369 25.4734C22.9066 26.6253 23.8833 27.5612 24.9995 27.5612C26.1157 27.5612 27.0924 26.6253 27.1621 25.4734L28.2086 13.8106C28.3481 11.7948 26.8831 10.2109 24.9995 10.2109Z"
      fill="white"
    />
    <path
      d="M24.9997 29.7209C23.6045 29.7209 22.4883 30.8728 22.4883 32.3127C22.4883 33.7525 23.6045 34.9044 24.9997 34.9044C26.395 34.9044 27.5112 33.7525 27.5112 32.3127C27.5112 30.8728 26.395 29.7209 24.9997 29.7209Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-0.0228992"
        y1="21.1943"
        x2="50.0091"
        y2="21.1943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const IconInstructionNotes =  ({className}) => (
  <svg  className={`cicon bg ${className}`} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4273 3.01299C11.5928 2.84749 11.8261 2.76875 12.0581 2.8001L14.3702 3.11261C14.7047 3.15783 14.9678 3.421 15.013 3.75555L15.325 6.06807C15.3563 6.29999 15.2776 6.53322 15.1121 6.6987L6.37339 15.4374C6.05303 15.7578 5.65162 15.985 5.21211 16.0949L2.18197 16.8527C1.92637 16.9166 1.65598 16.8417 1.46969 16.6554C1.28339 16.4691 1.2085 16.1987 1.27242 15.9432L2.03018 12.913C2.14008 12.4735 2.36735 12.0721 2.68768 11.7517L9.76272 4.67742C9.76909 4.67056 9.77561 4.66379 9.78229 4.65711C9.78899 4.65041 9.79578 4.64387 9.80266 4.63748L11.4273 3.01299ZM3.74838 12.8124L10.313 6.24844L11.877 7.81248L5.31273 14.3768C5.18458 14.5049 5.02402 14.5958 4.84822 14.6397L3.03091 15.0942L3.48537 13.2769C3.52933 13.1011 3.62024 12.9405 3.74838 12.8124ZM13.7888 5.90064L12.9377 6.75182L11.3737 5.18784L12.2253 4.33634L13.6029 4.52254L13.7888 5.90064Z" fill="#687D96"/>
    <path d="M18.2805 15.7804C18.5734 15.4875 18.5734 15.0126 18.2805 14.7197C17.9876 14.4268 17.5128 14.4268 17.2199 14.7197L16.2627 15.6769C15.4984 16.441 14.2593 16.441 13.495 15.6769L13.4941 15.676C12.143 14.3298 9.95755 14.3298 8.60639 15.676C8.31296 15.9684 8.31208 16.4432 8.60444 16.7367C8.89679 17.0301 9.37167 17.031 9.6651 16.7386C10.4308 15.9757 11.6692 15.9756 12.4351 16.7383C13.7852 18.0874 15.9733 18.0873 17.3232 16.7377L18.2805 15.7804Z" fill="#687D96"/>
  </svg>
)